export const numberColumn = {
  filter: 'agNumberColumnFilter'
}
